exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".container-ag-grid {\n  height: 50vh; }\n\n@media (max-width: 1366px) {\n  .container-ag-grid {\n    height: 42vh; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/billing-general/posting/grid-posting-batch/grid-posting-batch.component.scss
// module id = 1977
// module chunks = 66